window.addEventListener("scroll", () => {
  const stickyAddToCart = document.querySelector(
    ".snippet__sticky-add-to-cart"
  );
  const scrollTop = window.scrollY || document.documentElement.scrollTop;
  const windowHeight =
    document.documentElement.scrollHeight - window.innerHeight;
  const scrolledPercentage = (scrollTop / windowHeight) * 100;

  if (scrolledPercentage >= 35 && scrolledPercentage < 90) {
    stickyAddToCart.classList.add("is-visible");
  } else {
    stickyAddToCart.classList.remove("is-visible");
  }
});
